// extracted by mini-css-extract-plugin
export default {"infoList":"infoList---C0Mr7","checkboxWithHelp":"checkboxWithHelp---d3fje"};